import { HttpErrorResponse } from '@angular/common/http';

/**
 * Parses ASP.NET Core ProblemDetails / ValidationProblemDetails bodies.
 *
 * - ValidationProblemDetails (400): errors object contains per-field arrays → flatten and join
 * - ProblemDetails (409, 404, etc.): human-readable message is in `title`
 * - Falls back to the Angular HttpErrorResponse.message as a last resort
 */
export function parseProblemDetailsError(error: HttpErrorResponse, fallback: string): string {
  const body = error.error as Record<string, unknown> | null;
  if (!body) return fallback;

  if (body['errors'] && typeof body['errors'] === 'object') {
    const messages = Object.values(body['errors'] as Record<string, string[]>).flat();
    if (messages.length > 0) return messages.join(' ');
  }

  if (typeof body['title'] === 'string' && body['title']) return body['title'];

  return error.message ?? fallback;
}

/**
 * Attempts to break a "...for the following providers: A, B, C. Edit them instead." message
 * into a header, an item-per-provider list, and a footer for structured display.
 * Returns null if the message doesn't match the expected pattern.
 */
export function parseProviderConflictError(raw: string): { message: string; items: string[] } | null {
  const match = raw.match(/^(.+? for the following providers:) (.+?)\. Edit them instead\.?$/i);
  if (!match) return null;

  const [, header, providerList] = match;
  const items = providerList.split('), ').map((entry, index, arr) => {
    const full = index < arr.length - 1 ? entry + ')' : entry;
    const entryMatch = full.match(/^(.+?) \('(.+?)', ID \d+\)$/);
    if (entryMatch) {
      const [, providerName, scheduleName] = entryMatch;
      return `Provider Name: "${providerName.trim()}"  |  Schedule Name: "${scheduleName.trim()}"`;
    }
    return full;
  });

  return { message: header, items };
}
